import React, { useContext, useState } from "react";
import WebHomeProvider from "../../../Provider/WebHomeProvider";
import { InputText, Model } from "../../../Widgets";
import defaultImg from "../../../Assets/Images/pro.png";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Empty, Spin } from "antd";
const ProductSearch = () => {
  const {
    productSearchLoader,
    setProductSearchLoader,
    productSearchPopup,
    setProductSearchPopup,
    productSearchList,
    setProductSearchList,
    fetchProductSearch,
  } = useContext(WebHomeProvider);
  const [searchValue, setSearchValue] = useState("");
  return (
    <ProSerachSection>
      <Model
        open={productSearchPopup}
        oncancel={() => setProductSearchPopup(false)}
        title={"Product Search"}
        body={
          <div className="product_search">
            <InputText
              value={searchValue}
              onchange={(e) => {
                fetchProductSearch(
                  e.target.value === "" ? null : e.target.value
                );
                setSearchValue(e.target.value);
              }}
              placeholder="Search"
            />
            {productSearchLoader && (
              <div className="loader_s d_f a_i_c j_c_c">
                <Spin />
              </div>
            )}
            {!productSearchLoader && productSearchList?.length === 0 && (
              <div className="loader_s d_f a_i_c j_c_c p_t_30">
                <Empty
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description="Search Products"
                />
              </div>
            )}
            <div className="product_search_list">
              {productSearchList?.length > 0 &&
                productSearchList?.map((e, i) => {
                  const { product_gallery } = e;
                  const image = product_gallery?.split("|")[0];
                  return (
                    <Link
                      to={`/product/${e?.product_slug}`}
                      title={e?.product_name}
                      onClick={() => {
                        setProductSearchPopup(false);
                        fetchProductSearch("");
                        setProductSearchList([]);
                      }}
                    >
                      <div className="search_card">
                        <div className="search_left">
                          <img
                            src={
                              image
                                ? process.env.REACT_APP_UPLOAD_URL + image
                                : defaultImg
                            }
                            alt={e?.title}
                          />
                        </div>
                        <div className="search_right">
                          <h4>{e?.product_name}</h4>
                        </div>
                      </div>
                    </Link>
                  );
                })}
            </div>
          </div>
        }
      />
    </ProSerachSection>
  );
};

export default ProductSearch;

const ProSerachSection = styled.section`
  .search_card {
    display: flex;
  }
`;
